import MarketMain from "./main.vue";
let a = Object.assign({MarketMain}, {})
export default a;
